<div class="modal-body flex flex-col box-border">
  <header class="modal-header grow-0">
    <div class="flex justify-between items-start gap-4">
      <h2 *ngIf="bulkDeletion && !plannedDeletionFlag" class="modal-headline grow" i18n>Delete assets</h2>
      <h2 *ngIf="!bulkDeletion && !plannedDeletionFlag" class="modal-headline grow" i18n>Delete the asset</h2>
      <h2 *ngIf="plannedDeletionFlag" class="modal-headline grow" i18n>Plan asset deletion</h2>
      <button mat-icon-button [mat-dialog-close]="false" class="button-close ml-auto grow-0">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="modal-main flex flex-col justify-between items-start grow">
    <div *ngIf="bulkDeletion && !plannedDeletionFlag" i18n>If you choose to delete selected assets, they will be removed from the platform</div>
    <div *ngIf="!bulkDeletion && !plannedDeletionFlag" i18n>If you choose to delete the asset, it will be removed from the platform</div>
    <div class="mt-5">
      <span class="w-2/5 field-label" i18n>Plan deletion</span>
      <mat-form-field class="w-3/5" appearance="outline" floatLabel="auto">
        <input matInput [min]="currentDate" [matDatepicker]="picker" [formControl]="plannedDeletionDate" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <footer class="modal-footer !flex !flex-col grow-0">
    <div class="flex justify-end items-center gap-4">
      <button mat-flat-button class="button-secondary" (click)="planDeletion()" [disabled]="plannedDeletionDate.invalid || !plannedDeletionDate.value" i18n>Plan deletion</button>
      <button *ngIf="!plannedDeletionFlag" mat-flat-button class="button-primary" (click)="deleteAsset()" i18n>Delete</button>
    </div>
  </footer>
</div>
